import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Box,
  TextField,
  InputAdornment,
  Autocomplete,
  Typography,
  Divider,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import BusinessIcon from "@mui/icons-material/Business";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from '@mui/material/styles';
import axios from "axios";

import { useAuth } from "../../../../context/AuthContext";
import { useSystems } from "../../../../context/SystemContext";
import CarritoDrawer from "../../../navbar/navVers03/CarritoDrawer.jsx";
import ProfessionalSearchView from "../../../navbar/navVers03/movil/ProfessionalSearchView.jsx";
import ProfessionalHistoryPC from "../../../navbar/navVers03/ProfessionalHistoryPC.jsx";
import NotificationBell from "../../../../components/notifications/NotificationBell.jsx";
import ProPlanModal from "../../../components/pro/ProPlanModal";

const SearchField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#f5f7fa',
    borderRadius: '1.2rem',
    fontWeight: 600,
    '& fieldset': { border: 'none' },
    '&:hover': { backgroundColor: '#f0f2f5' },
    '&.Mui-focused': { backgroundColor: '#fff', boxShadow: '0 0 0 2px #8b5cf633' }
  }
});

function BarraDeNavegacion({ onMenuClick }) {
  const { user, logout } = useAuth(); 
  const { setHistoryVisible, activeProfile, setActiveProfile } = useSystems();
  const navigate = useNavigate();
  const location = useLocation();
  const [usuarios, setUsuarios] = useState([]); // Garantizamos que inicie como array
  const [busqueda, setBusqueda] = useState("");
  const [userData, setUserData] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [avatarAnchorEl, setAvatarAnchorEl] = useState(null);
  const [isProModalOpen, setIsProModalOpen] = useState(false);
  const [trialVencido, setTrialVencido] = useState(false);
  const [proActivo, setProActivo] = useState(false);
  const [pendingProfile, setPendingProfile] = useState(null);
  const [profiles, setProfiles] = useState(() => {
    try {
      const cached = localStorage.getItem('cached_profiles');
      return cached ? JSON.parse(cached) : [];
    } catch { return []; }
  });

  useEffect(() => {
    const uid = user?.user_id || user?.id || 1500;
    // Siempre consultar API (incluso con uid 1500)
    fetch("https://apiweb.hitpoly.com/ajax/trialsController.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ accion: "estado", usuario_id: uid }),
    })
      .then((r) => r.json())
      .then((d) => {
        const rawLocal = localStorage.getItem("hitpoly_trial");
        const finFuture = (d && d.fin && new Date(d.fin).getTime() > Date.now());
        const activoReal = (d && d.status === "success" && (d.activo || finFuture));
        if (activoReal) {
          setTrialVencido(false);
          setProActivo(true);
          // Sincronizar caché local con el estado real de la API
          try {
            localStorage.setItem("hitpoly_trial", JSON.stringify({ fin: d.fin, origen: d.origen || "prueba" }));
          } catch (e) {}
        } else if (d && d.status === "success" && !d.activo) {
          setProActivo(false);
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              setTrialVencido(!!(d && d.fin));
            }
          } catch (e) {
            localStorage.removeItem("hitpoly_trial");
            setTrialVencido(false);
          }
        } else {
          setProActivo(false);
          try {
            if (rawLocal) {
              const t = JSON.parse(rawLocal);
              if (t && t.fin && new Date(t.fin).getTime() <= Date.now()) {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(true);
              } else {
                localStorage.removeItem("hitpoly_trial");
                setTrialVencido(false);
              }
            } else {
              setTrialVencido(false);
            }
          } catch (e) {
            setTrialVencido(false);
          }
        }
      })
      .catch((err) => {
        try {
          const raw = localStorage.getItem("hitpoly_trial");
          if (raw) {
            const t = JSON.parse(raw);
            if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
              setTrialVencido(false);
              setProActivo(true);
            } else {
              localStorage.removeItem("hitpoly_trial");
              setProActivo(false);
              setTrialVencido(!!raw);
            }
          } else {
            setProActivo(false);
            setTrialVencido(false);
          }
        } catch (e) {
          setProActivo(false);
          setTrialVencido(false);
        }
      });
  }, [user?.user_id, user?.id]);

  // Escuchar activación de prueba desde otros componentes (modal, sidebar, etc.)
  useEffect(() => {
    const handleProTrialStarted = () => {
      try {
        const raw = localStorage.getItem("hitpoly_trial");
        if (raw) {
          const t = JSON.parse(raw);
          if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
            setProActivo(true);
            setTrialVencido(false);
          } else {
            localStorage.removeItem("hitpoly_trial");
          }
        }
      } catch (e) {}
    };
    window.addEventListener("pro-trial-started", handleProTrialStarted);
    return () => window.removeEventListener("pro-trial-started", handleProTrialStarted);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
    const currentUserId = user?.user_id || user?.id;
    if (!currentUserId) return;
      try {
        const response = await axios.post("https://apiweb.hitpoly.com/ajax/traerUsuariosController.php", {
          accion: "getDataUsuarioPorId",
          id: currentUserId,
          viewer_id: currentUserId 
        });
        if (response.data.success && response.data.datos) {
          setUserData(response.data.datos);
        }
      } catch (error) {
        
      }
    };
    fetchUserData();
  }, [user?.user_id, user?.id]);

  // Fetch profiles from the Holding backend
  useEffect(() => {
    const currentUserId = user?.user_id || user?.id;
    if (!currentUserId) return;

    axios.post('https://apiweb.hitpoly.com/ajax/perfilesController.php', {
      user_id: currentUserId
    })
    .then(res => {
      const data = res.data?.data?.profiles;
      if (Array.isArray(data)) {
        setProfiles(data);
        try { localStorage.setItem('cached_profiles', JSON.stringify(data)); } catch (e) {}
        if (!activeProfile && data.length > 0) {
          const p = data[0];
          const profile = { id: p.id, type: p.type, name: p.name, label: p.label, avatar: p.avatar };
          setActiveProfile(profile);
        }
      }
    })
    .catch(() => {});
  }, [user?.user_id, user?.id]);

  // Sincronizar activeProfile con la URL (navegación atrás/adelante del navegador)
  useEffect(() => {
    const path = location.pathname;
    const params = new URLSearchParams(location.search);
    const urlUserId = params.get('userId');

    const setMainProfile = () => {
      const mainProfile = profiles.find(p => p.type === 'main');
      if (mainProfile) {
        const p = { id: mainProfile.id, type: mainProfile.type, name: mainProfile.name, label: mainProfile.label, avatar: mainProfile.avatar };
        if (p.id !== activeProfile?.id || p.type !== activeProfile?.type) {
          setActiveProfile(p);
          localStorage.setItem('holding_active_profile', JSON.stringify(p));
        }
      }
    };

    if (path === '/perfil-de-usuario') {
      setMainProfile();
      return;
    }

    if (path.startsWith('/systems/')) {
      if (path.startsWith('/systems/bolsa')) {
        const enterpriseMatch = path.match(/\/systems\/bolsa\/editar-empresa\/(\d+)/);
        if (enterpriseMatch) {
          const companyId = enterpriseMatch[1];
          const match = profiles.find(p => String(p.id) === companyId && p.type === 'enterprise');
          if (match && (match.id !== activeProfile?.id || match.type !== activeProfile?.type)) {
            const p = { id: match.id, type: match.type, name: match.name, label: match.label, avatar: match.avatar };
            setActiveProfile(p);
            localStorage.setItem('holding_active_profile', JSON.stringify(p));
          }
          return;
        }

        if (urlUserId) {
          const match = profiles.find(p => String(p.id) === urlUserId && (p.type === 'professional' || p.type === 'enterprise'));
          if (match && (match.id !== activeProfile?.id || match.type !== activeProfile?.type)) {
            const p = { id: match.id, type: match.type, name: match.name, label: match.label, avatar: match.avatar };
            setActiveProfile(p);
            localStorage.setItem('holding_active_profile', JSON.stringify(p));
          }
        }
      }
    } else {
      // Rutas del holding que NO son iframe (dashboard, search, etc.)
      // NO forzar perfil main - mantener el perfil que el usuario ya tiene seleccionado
    }
  }, [location.pathname, location.search, profiles]);

  useEffect(() => {
    const currentUserId = user?.user_id || user?.id;
    
    const buscarUsuarios = async () => {
      if (busqueda.length < 2 || !currentUserId) {
        setUsuarios([]);
        return;
      }

      try {
        const response = await axios.post("https://apiweb.hitpoly.com/ajax/traerUsuariosController.php", {
          accion: "searchUsersGlobal", 
          query: busqueda,
          viewer_id: currentUserId 
        });
        
        if (response.data.success && Array.isArray(response.data.datos)) {
          setUsuarios(response.data.datos);
        } else {
          setUsuarios([]); 
        }
      } catch (error) {
        setUsuarios([]); 
      }
    };

    const timeoutId = setTimeout(buscarUsuarios, 300);
    return () => clearTimeout(timeoutId);
  }, [busqueda, user?.user_id, user?.id]);

  const handleSelect = (event, value) => {
    if (!value) return;

    if (value.isHistoryLink) {
      setHistoryVisible(true);
      return;
    }

    if (typeof value === 'string') {
      // Si el usuario escribe y da enter → ir a la página de resultados
      guardarBusqueda(value);
      navigate(`/search/top?q=${encodeURIComponent(value)}`);
      setBusqueda("");
      return;
    }

    const slug = `${value.nombre.toLowerCase()}.${value.apellido.toLowerCase()}`.replace(/\s+/g, '');
    guardarVisita(value);
    navigate(`/${slug}`, { state: { targetId: value.id } });
  };

  const guardarBusqueda = async (texto) => {
    const currentUserId = user?.user_id || user?.id;
    if (!currentUserId || !texto) return;
    try {
      await axios.post("https://apiweb.hitpoly.com/ajax/buscarProfesionalesController.php", {
        accion: "saveSelection",
        user_id: currentUserId,
        query: texto,
        type: "search"
      });
    } catch (e) {}
  };

  const guardarVisita = async (perfil) => {
    const currentUserId = user?.user_id || user?.id;
    if (!currentUserId) return;
    try {
      await axios.post("https://apiweb.hitpoly.com/ajax/buscarProfesionalesController.php", {
        accion: "saveSelection",
        user_id: currentUserId,
        query: `${perfil.nombre} ${perfil.apellido}`,
        type: "visit",
        target_id: perfil.id
      });
    } catch (e) {}
  };

  const handleAvatarClick = (event) => setAvatarAnchorEl(event.currentTarget);
  const handleAvatarClose = () => setAvatarAnchorEl(null);

  const handleProfileSelect = (profile) => {
    // Si es perfil profesional o empresa, requiere Pro activo (prueba o pago)
    if (profile.type === 'professional' || profile.type === 'enterprise') {
      // 1) Estado real obtenido de la API (mismo criterio que el nav vertical)
      if (proActivo) {
        aplicarSeleccionPerfil(profile);
        return;
      }
      // 2) Fallback: caché local vigente (si la API no respondió)
      try {
        const raw = localStorage.getItem("hitpoly_trial");
        if (raw) {
          const t = JSON.parse(raw);
          if (t && t.fin && new Date(t.fin).getTime() > Date.now()) {
            setProActivo(true);
            aplicarSeleccionPerfil(profile);
            return;
          }
          localStorage.removeItem("hitpoly_trial");
        }
      } catch (e) {}
      // Sin Pro activo: abrir modal (con banner de vencido si la prueba ya venció)
      setPendingProfile(profile);
      setIsProModalOpen(true);
      handleAvatarClose();
      return;
    }

    aplicarSeleccionPerfil(profile);
  };

  const aplicarSeleccionPerfil = (profile) => {
    const p = { id: profile.id, type: profile.type, name: profile.name, label: profile.label, avatar: profile.avatar };
    setActiveProfile(p);
    handleAvatarClose();
    
    const currentUserId = user?.user_id || user?.id;
    if (profile.type === 'main') {
      navigate('/perfil-de-usuario?tab=Publicaciones');
    } else if (profile.type === 'professional') {
      navigate(`/systems/bolsa/perfil-profesional/${profile.id}?userId=${currentUserId}`);
    } else if (profile.type === 'enterprise') {
      navigate(`/systems/bolsa/empresa/${profile.id}?userId=${currentUserId}`);
    }
  };

  // Reanudar destino pendiente tras crear un perfil profesional/empresa en la bolsa.
  // Se dispara al cambiar de ruta, al recuperar el foco de la ventana y al refetch de perfiles.
  useEffect(() => {
    let cancelado = false;

    const intentarReanudar = async () => {
      let pend = null;
      try {
        const raw = localStorage.getItem('pending_pro_destination');
        if (!raw) return;
        pend = JSON.parse(raw);
      } catch (e) { return; }
      if (!pend || !pend.route) {
        localStorage.removeItem('pending_pro_destination');
        return;
      }
      // Expirar después de ~30 minutos
      if (!pend.t || Date.now() - pend.t > 30 * 60 * 1000) {
        localStorage.removeItem('pending_pro_destination');
        sessionStorage.removeItem('bolsa_crear_tipo');
        return;
      }
      const currentUserId = user?.user_id || user?.id;
      if (!currentUserId) return;

      try {
        const res = await axios.post('https://apiweb.hitpoly.com/ajax/perfilesController.php', {
          user_id: currentUserId
        });
        if (cancelado) return;
        const data = res.data?.data?.profiles;
        const list = Array.isArray(data) ? data : [];
        if (Array.isArray(data)) {
          setProfiles(data);
          try { localStorage.setItem('cached_profiles', JSON.stringify(data)); } catch (e) {}
        }
        const beforeIds = (Array.isArray(pend.before) ? pend.before : []).map(b => String(b.id));
        // Solo reanudar cuando aparezca un perfil pro/empresa NUEVO (no estaba en el snapshot)
        const nuevos = list.filter(p => (p.type === 'professional' || p.type === 'enterprise') && !beforeIds.includes(String(p.id)));
        const elegido = nuevos[0] || (beforeIds.length === 0
          ? list.find(p => p.type === 'professional' || p.type === 'enterprise')
          : null);
        if (!elegido) return; // aún no se crea; reintentar en el próximo disparo
        localStorage.removeItem('pending_pro_destination');
        sessionStorage.removeItem('bolsa_crear_tipo');
        const p = { id: elegido.id, type: elegido.type, name: elegido.name, label: elegido.label, avatar: elegido.avatar };
        setActiveProfile(p);
        localStorage.setItem('holding_active_profile', JSON.stringify(p));
        navigate(pend.route);
      } catch (e) {}
    };

    intentarReanudar();
    const onFocus = () => intentarReanudar();
    window.addEventListener('focus', onFocus);
    return () => {
      cancelado = true;
      window.removeEventListener('focus', onFocus);
    };
  }, [location.pathname, location.search, user?.user_id, user?.id]);

  const avatarUrl = activeProfile?.avatar || userData?.avatar || user?.avatar || "";
  const userName = userData?.nombre || user?.nombre || "Usuario";

  return (
    <AppBar 
      position="relative" 
      className="header-no-scroll"
      sx={{ 
        backgroundColor: "white", 
        color: "black", 
        boxShadow: "0 1px 0px rgba(0,0,0,0.05)", 
        zIndex: 100005,
      }}
    >
      <style>
        {`
          .header-no-scroll::-webkit-scrollbar { display: none; } 
          .header-no-scroll { 
            scrollbar-width: none; 
            -ms-overflow-style: none; 
          }
        `}
      </style>

      <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: { xs: 1, md: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, md: 3 }, flexGrow: 1 }}>
          <Link to="/dashboardsistem" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <Box 
              component="img" 
              src="/images/logo-hitpoly.png" 
              alt="HitPoly Logo" 
              sx={{ height: { xs: 35, md: 50 }, width: { xs: 130, md: 190 } }} 
            />
          </Link>

          <Box sx={{ display: { xs: 'none', sm: 'block' }, width: "350px" }}>
            <Autocomplete
              freeSolo
              disableClearable
              options={[{ isHistoryLink: true }, ...(usuarios || [])]}
              getOptionLabel={(option) => {
                if (option.isHistoryLink) return "";
                return typeof option === 'string' ? option : `${option.nombre} ${option.apellido}`;
              }}
              onInputChange={(event, newInputValue) => setBusqueda(newInputValue)}
              onChange={handleSelect}
              slotProps={{
                popper: {
                  sx: { zIndex: 10000 } 
                },
                paper: {
                  sx: { boxShadow: '0 4px 20px rgba(0,0,0,0.15)', borderRadius: '1rem', mt: 1 }
                }
              }}
              renderOption={(props, option) => {
                if (option.isHistoryLink) {
                  return (
                    <Box 
                      component="li" 
                      {...props} 
                      key="history-link"
                      sx={{ 
                        p: 1.5, 
                        borderBottom: '1px solid #f0f0f0', 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 1.5,
                        color: '#1877f2',
                        cursor: 'pointer',
                        '&:hover': { bgcolor: '#f0f2f5' }
                      }}
                    >
                      <AccessTimeIcon sx={{ fontSize: 20 }} />
                      <Typography variant="body2" fontWeight="bold">Ver historial de búsqueda</Typography>
                    </Box>
                  );
                }
                return (
                  <Box component="li" {...props} key={option.id} sx={{ display: 'flex', gap: 2, p: 1.5 }}>
                    <Avatar src={option.avatar} sx={{ width: 35, height: 35 }}>{option.nombre?.charAt(0)}</Avatar>
                    <Box>
                      <Typography variant="body2" fontWeight={700}>{option.nombre} {option.apellido}</Typography>
                      <Typography variant="caption" color="text.secondary">Ver perfil profesional</Typography>
                    </Box>
                  </Box>
                );
              }}
              renderInput={(params) => (
                <SearchField 
                  {...params} 
                  placeholder="Buscar profesionales..." 
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "#adb5bd", ml: 0.5 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, md: 1.5 } }}>
          {user && (
            <IconButton 
              onClick={() => setIsSearchOpen(true)} 
              sx={{ 
                color: "#64748b", 
                bgcolor: '#f8fafc', 
                display: { xs: 'flex', md: 'none' },
                mr: 0.5 
              }}
            >
              <SearchIcon />
            </IconButton>
          )}
          <CarritoDrawer />
          
          <NotificationBell />

          <IconButton 
            onClick={handleAvatarClick}
            sx={{ p: 0.5, border: activeProfile ? '2px solid #8b5cf6' : '2px solid transparent', '&:hover': { borderColor: '#8b5cf6' } }}
          >
            <Avatar src={avatarUrl} sx={{ width: { xs: 32, md: 38 }, height: { xs: 32, md: 38 }, bgcolor: "#8b5cf6" }}>
              {userName.charAt(0).toUpperCase()}
            </Avatar>
          </IconButton>
          <Menu
            anchorEl={avatarAnchorEl}
            open={Boolean(avatarAnchorEl)}
            onClose={handleAvatarClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            disablePortal
            slotProps={{ paper: { sx: { minWidth: 200, mt: 1, borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', zIndex: 1000000 } } }}
          >
            <Box sx={{ px: 2, py: 1, borderBottom: '1px solid #eee' }}>
              <Typography variant="subtitle2" fontWeight={700}>{userName}</Typography>
              <Typography variant="caption" color="text.secondary">Seleccionar perfil</Typography>
            </Box>
            {profiles.map((p) => {
              const isActive = activeProfile?.id === p.id && activeProfile?.type === p.type;
              return (
                <MenuItem key={`${p.type}-${p.id}`} onClick={() => handleProfileSelect(p)} selected={isActive} sx={{ py: 1 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    {p.avatar ? (
                      <Avatar src={p.avatar} sx={{ width: 24, height: 24 }} />
                    ) : (
                      <PersonIcon fontSize="small" />
                    )}
                  </ListItemIcon>
                  <ListItemText>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <Typography variant="body2" fontWeight={isActive ? 700 : 400}>{p.name}</Typography>
                      <Typography variant="caption" sx={{ fontSize: '0.6rem', color: 'primary.main', fontWeight: 600 }}>{p.label}</Typography>
                    </Box>
                  </ListItemText>
                  {isActive && <CheckIcon fontSize="small" sx={{ color: '#8b5cf6' }} />}
                </MenuItem>
              );
            })}
            {(!profiles.some(p => p.type === 'professional') || !profiles.some(p => p.type === 'enterprise')) && (
              <Divider sx={{ my: 0.5 }} />
            )}
            {!profiles.some(p => p.type === 'professional') && (
              <MenuItem onClick={() => { handleAvatarClose(); sessionStorage.setItem('bolsa_crear_tipo', 'professional'); navigate('/systems/bolsa?reset=true'); }} sx={{ py: 1 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <PersonAddIcon fontSize="small" sx={{ color: '#F21C63' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography variant="body2" fontWeight={500}>Crear perfil profesional</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">Muestra tu talento</Typography>
                </ListItemText>
              </MenuItem>
            )}
            {!profiles.some(p => p.type === 'enterprise') && (
              <MenuItem onClick={() => { handleAvatarClose(); sessionStorage.setItem('bolsa_crear_tipo', 'enterprise'); navigate('/systems/bolsa?reset=true'); }} sx={{ py: 1 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <BusinessIcon fontSize="small" sx={{ color: '#6C4DE2' }} />
                </ListItemIcon>
                <ListItemText>
                  <Typography variant="body2" fontWeight={500}>Crear perfil empresa</Typography>
                  <Typography variant="caption" color="text.secondary" display="block">Encuentra talento global</Typography>
                </ListItemText>
              </MenuItem>
            )}
          </Menu>

          <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
            <Divider 
              orientation="vertical" 
              flexItem 
              sx={{ mx: 1, height: 24, alignSelf: 'center', borderColor: 'rgba(0,0,0,0.12)' }} 
            />
            <IconButton 
              onClick={onMenuClick} 
              sx={{ 
                color: "#64748b",
                '&:active': { backgroundColor: '#f0f2f5' }
              }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>

      {/* Vista de Buscador Profesional en Móvil */}
      {isSearchOpen && (
        <ProfessionalSearchView onClose={() => setIsSearchOpen(false)} />
      )}

      <ProPlanModal vencido={trialVencido}
        open={isProModalOpen}
        onClose={() => { setIsProModalOpen(false); setPendingProfile(null); }}
        herramienta="Perfil Profesional / Empresa"
        onTrialStarted={(fin) => {
          setProActivo(true);
          setTrialVencido(false);
          setIsProModalOpen(false);
          if (pendingProfile) {
            const profile = pendingProfile;
            setPendingProfile(null);
            aplicarSeleccionPerfil(profile);
          }
        }}
      />

    </AppBar>
  );
}

export default BarraDeNavegacion;
